<div fxLayout="column" fxLayoutAlign="start center" class="message">
  <h3>
    Unfortunately, {{ survey?.displayTitle }} is closed. We apologize for the
    inconvenience.
  </h3>
</div>
